import api from "api";

const partnerOnboarding = {
    create: (formData) => {
        return api(false, true).post('/partner-onboardings', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    validate: (formData) => {
        return api(false, true).post('/partner-onboardings/validate', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
};

export default partnerOnboarding;
